"use strict";
import * as React from "react";
import { Translation } from "../../components";
import { locationService } from "../../services";
import { getPluginSrv, importAppPagePlugin } from "../../services/PluginService";
import { Box, Button, Divider, Grid, Loading, Message, Tab } from "@alifd/next";
import "./index.less";
import { connect } from "dva";
import { renderIcon } from "../../utils/icon";
function RootPage({ pluginId }) {
  const [app, setApp] = React.useState();
  React.useEffect(() => {
    loadAppPlugin(pluginId, setApp);
  }, [pluginId]);
  if (!app || !app.root) {
    return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(Translation, null, "No root app page component found"));
  }
  const AppRootPage2 = app.root;
  return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(AppRootPage2, { meta: app.meta, basename: locationService.getLocation().pathname }));
}
var types = /* @__PURE__ */ ((types2) => {
  types2[types2["UPDATE_META"] = 0] = "UPDATE_META";
  return types2;
})(types || {});
function ConfigPage({ pluginId, dispatch, pluginList, loading }) {
  const [app, setApp] = React.useState();
  const _meta = pluginList.filter((item) => item.id === pluginId)[0];
  const updateMeta = (previousState, action) => {
    if (action.type == 0 /* UPDATE_META */) {
      return { ...previousState, ...action.payload };
    }
    throw new Error("Unknown action type");
  };
  const [meta, dispatchMeta] = React.useReducer(updateMeta, _meta);
  const handleJSONChange = (key, value) => {
    const newJsonData = { ...meta.jsonSetting };
    newJsonData[key] = value;
    meta.jsonSetting = newJsonData;
    setApp({ ...app, meta });
  };
  const handleSecureJSONChange = (key, value) => {
    const newSecureJsonData = { ...meta.secureJsonData };
    newSecureJsonData[key] = value;
    meta.secureJsonData = newSecureJsonData;
    setApp({ ...app, meta });
  };
  React.useEffect(() => {
    if (!meta) {
      getPluginSrv().loadMeta(pluginId).then(
        (m) => {
          dispatchMeta({
            type: 0 /* UPDATE_META */,
            payload: m
          });
        }
      );
    }
  }, [meta, pluginId]);
  React.useEffect(() => {
    if (!meta) {
      return;
    }
    importAppPagePlugin(meta).then((pageApp) => {
      setApp(pageApp);
    }).catch((err) => {
      console.log(err);
    });
  }, [meta]);
  if (!meta || !app || !app.configPages || !app.configPages.body) {
    return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(Translation, null, "No config app page component found"));
  }
  const { Col, Row } = Grid;
  const isEnabled = meta.enabled;
  const isInstalled = !!meta.info;
  const saveSetting = () => {
    dispatch({
      type: "plugins/setPlugin",
      payload: {
        id: pluginId,
        jsonData: meta.jsonSetting,
        secureJsonData: meta.secureJsonData
      },
      callback: () => {
        Message.success("Setting saved");
      }
    });
  };
  const saveAndEnable = () => {
    dispatch({
      type: "plugins/enablePlugin",
      payload: {
        id: pluginId,
        jsonData: meta.jsonSetting,
        secureJsonData: meta.secureJsonData
      },
      callback: () => {
        meta.enabled = true;
        Message.success("Plugin enabled");
      }
    });
  };
  const disablePlugin = (id) => {
    dispatch({
      type: "plugins/disablePlugin",
      payload: { id },
      callback: () => {
        meta.enabled = false;
        Message.success("Plugin disabled");
      }
    });
  };
  const uninstallPlugin = (id) => {
    dispatch({
      type: "plugins/uninstallPlugin",
      payload: { id },
      callback: () => {
        const history = locationService.getHistory();
        history.push("/plugins");
      }
    });
  };
  const handleGotoPlugins = () => {
    const history = locationService.getHistory();
    history.push("/manage/plugins");
  };
  const AppConfigPage2 = app.configPages.body;
  return /* @__PURE__ */ React.createElement(Box, null, /* @__PURE__ */ React.createElement(Loading, { visible: loading.models.plugins ?? false, fullScreen: true }), /* @__PURE__ */ React.createElement(Box, { className: "container" }, /* @__PURE__ */ React.createElement(Box, { className: "page-header", direction: "row", spacing: 12 }, /* @__PURE__ */ React.createElement("span", { className: "page-header-logo" }, renderIcon(meta.id, meta.info?.logos.large, "80px")), /* @__PURE__ */ React.createElement(Box, { direction: "column" }, /* @__PURE__ */ React.createElement("h1", { className: "page-header-title" }, /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("a", { onClick: handleGotoPlugins }, "Plugins"), " / ", meta.name)), /* @__PURE__ */ React.createElement("h4", { className: "font-size-14" }, meta.info.description ?? "No descriptions")), /* @__PURE__ */ React.createElement(Box, { style: { marginLeft: "auto" }, align: "flex-end", direction: "row", justify: "flex-end" }, /* @__PURE__ */ React.createElement(Box, { justify: "space-between", style: { height: "100%" } }, /* @__PURE__ */ React.createElement(Row, { className: "basic-info font-size-16", justify: "end" }, /* @__PURE__ */ React.createElement(Col, null, /* @__PURE__ */ React.createElement("div", { className: "info-item-title" }, "Version"), /* @__PURE__ */ React.createElement("div", null, meta.info.version)), /* @__PURE__ */ React.createElement(Col, null, /* @__PURE__ */ React.createElement(Divider, { direction: "ver", style: { height: "100%" } })), /* @__PURE__ */ React.createElement(Col, null, /* @__PURE__ */ React.createElement(Box, { direction: "column" }, /* @__PURE__ */ React.createElement("div", { className: "info-item-title" }, "Author"), /* @__PURE__ */ React.createElement("div", null, meta.info.author?.name ?? "Unknown"))), /* @__PURE__ */ React.createElement(Col, null, /* @__PURE__ */ React.createElement(Divider, { direction: "ver", style: { height: "100%" } })), /* @__PURE__ */ React.createElement(Col, { className: "info-item" }, /* @__PURE__ */ React.createElement("div", { className: "info-item-title" }, "Status"), /* @__PURE__ */ React.createElement("div", null, meta.enabled ? /* @__PURE__ */ React.createElement(Translation, { className: "status-enabled" }, "Enabled") : /* @__PURE__ */ React.createElement(Translation, { className: "status-disabled" }, "Disabled")))), /* @__PURE__ */ React.createElement(Box, { direction: "row", justify: "flex-end", spacing: 8 }, isInstalled && /* @__PURE__ */ React.createElement(
    Button,
    {
      disabled: meta?.addon === void 0,
      warning: true,
      onClick: () => uninstallPlugin(pluginId)
    },
    "Uninstall"
  )))))), /* @__PURE__ */ React.createElement(Box, { className: "container" }, /* @__PURE__ */ React.createElement(Tab, null, /* @__PURE__ */ React.createElement(Tab.Item, { title: "Config" }, /* @__PURE__ */ React.createElement(Box, { style: { backgroundColor: "#FFF", padding: "0 10px" } }, /* @__PURE__ */ React.createElement(
    AppConfigPage2,
    {
      plugin: app,
      query: {},
      onJSONDataChange: handleJSONChange,
      onSecureJSONDataChange: handleSecureJSONChange
    }
  ), /* @__PURE__ */ React.createElement(Box, { direction: "row", justify: "center", spacing: 10, margin: 20 }, !isEnabled && /* @__PURE__ */ React.createElement(Button, { type: "normal", onClick: saveSetting }, "Save"), !isEnabled && /* @__PURE__ */ React.createElement(Button, { type: "primary", onClick: saveAndEnable }, "Save & Enable"), isEnabled && /* @__PURE__ */ React.createElement(Button, { type: "primary", onClick: saveSetting }, "Save"), isEnabled && /* @__PURE__ */ React.createElement(Button, { type: "normal", warning: true, onClick: () => disablePlugin(pluginId) }, "Disable")))))));
}
async function loadAppPlugin(pluginId, setApp) {
  try {
    const app = await getPluginSrv().loadMeta(pluginId);
    if (app && "type" in app) {
      return importAppPagePlugin(app).then((pageApp) => {
        setApp(pageApp);
      }).catch((err) => {
        console.log(err);
      });
    }
  } catch (err) {
    console.log(err);
  }
}
const mapStateToProps = (store) => ({
  ...store.plugins,
  loading: store.loading
});
export const AppConfigPage = connect(mapStateToProps)(ConfigPage);
export const AppRootPage = connect(mapStateToProps)(RootPage);
